import { fetchNotifications } from "../services/notificationService";
import {
  FRIENDLY_SERVER_ERROR_MESSAGE,
  formatApiErrorMessage,
  isTechnicalApiErrorMessage,
} from "./apiErrorMessage";

export const LICENSE_ERROR_MESSAGES = {
  LICENSE_DOCUMENT_LIMIT_EXCEEDED:
    "Limite de documentos gerados já atingido. Renove sua licença ou adquira um plano com limites maiores para continuar gerando documentos.",
  LICENSE_SIGNATURE_LIMIT_EXCEEDED:
    "Você já extrapolou o limite de assinaturas para sua licença. Contate nosso time de suporte ou adquira uma nova licença.",
  LICENSE_NOT_FOUND: "Licença não encontrada.",
  LICENSE_NOT_VALID: "Licença inválida ou expirada.",
};

export function resolveApiErrorMessage(errorBody) {
  if (!errorBody) return "Erro ao gerar documento.";

  if (typeof errorBody === "string") {
    const trimmed = errorBody.trim();
    if (!trimmed) return "Erro ao gerar documento.";
    if (isTechnicalApiErrorMessage(trimmed)) {
      return FRIENDLY_SERVER_ERROR_MESSAGE;
    }
    return trimmed.replace(
      /\\u([0-9a-fA-F]{4})/g,
      (_, hex) => String.fromCharCode(parseInt(hex, 16))
    );
  }

  if (typeof errorBody === "object") {
    const code = errorBody.code;
    if (code && LICENSE_ERROR_MESSAGES[code]) {
      return LICENSE_ERROR_MESSAGES[code];
    }

    return formatApiErrorMessage(errorBody, "Erro ao gerar documento.");
  }

  return formatApiErrorMessage(errorBody, "Erro ao gerar documento.");
}

function extractMessageFromDocumentErrorNotification(notificationMessage) {
  if (!notificationMessage || typeof notificationMessage !== "string") {
    return null;
  }

  const match = notificationMessage.match(
    /Ocorreu um erro ao gerar o documento [^.]+\.\s*(.+)$/i
  );
  if (match?.[1]) {
    return match[1].trim();
  }

  return notificationMessage.trim() || null;
}

/**
 * When CloudFront replaces API 403/4xx with index.html (200), recover the real
 * message from the error notification the backend already sent.
 */
export async function fetchDocumentGenerationErrorFallback(maxAttempts = 3) {
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    try {
      const { items } = await fetchNotifications({ limit: 15 });
      const docError = (items || []).find(
        (notification) =>
          notification?.type === "error" &&
          /erro ao gerar documento/i.test(notification?.title || "")
      );

      if (docError?.message) {
        const extracted = extractMessageFromDocumentErrorNotification(docError.message);
        if (extracted) {
          return extracted;
        }
      }
    } catch (error) {
      console.warn("fetchDocumentGenerationErrorFallback:", error);
    }

    if (attempt < maxAttempts - 1) {
      await new Promise((resolve) => setTimeout(resolve, 600));
    }
  }

  return null;
}
